import React from "react";
import {Redirect, Route} from "react-router-dom";
import {getJwtToken} from "./Util/localCache";

const ProtectedRoute = ({component: Component, ...otherProps}) => {
    return (
        <Route {...otherProps} render={
            props => {
                let storedToken = getJwtToken();
                if (storedToken !== "" && storedToken !== null && storedToken.length > 0) return <Component {...otherProps} {...props}/>
                return (<Redirect to={
                    {
                        pathname: "/login",
                        state: {
                            from: props.location
                        }
                    }
                }/>)
            }
        }/>
    )
}

export default ProtectedRoute;
